import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { isMasked } from '@miq/utils';
import { Store } from '@ngxs/store';
import { L10nTranslationService } from 'angular-l10n';
import { CatalogMethod, CatalogResponse, CatalogsService, Column, LeaseColumns } from '@miq/catalog';
// tslint:disable-next-line:no-duplicate-imports
import moment, { Moment } from 'moment';
import { forkJoin, Observable, of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { FiltersService } from '../../../../../filters-toolbar/filters.service';
import { ConversionType, EfficiencyTransport, IUser } from '../../../../../models';
import { AbstractSpaceClass } from '../../../../../models/space/abstract-space.class';
import { NonRentableSpaceClass } from '../../../../../models/space/non-rentable-space.class';
import { TenantSpaceClass } from '../../../../../models/space/tenant-space.class';
import { SHOW_FLOOR_INDEX_FEATURE_KEY } from '../../../../../shared/constants/features.const';
import { NotificationService } from '../../../../../shared/services/notification.service';
import {
  findOwnerOccupiedColumn,
  formatDate,
  isOpportunityTabActive,
  isTenantEntityActive,
} from '../../../../../shared/utils/functions';
import { StackingPlanService } from '../../../../../stacking-plan.service';
import { ActionsToolbarService } from '../../../../actions-toolbar/actions-toolbar.service';
import { ConfirmDialogSPComponent } from '../../../../dialogs/confirm-dialog-sp/confirm-dialog-sp.component';
import { NonRentableSpaceComponent } from '../../../../dialogs/non-rentable-space/non-rentable-space.component';
import { NonRentableData } from '../../../../dialogs/non-rentable-space/non-rentable-space.model';
import { LovValues } from '../../../../../stacking-plan.model';
import { SuiteType } from '../item.model';
import { COLUMN_MAPPER_ENTITIES, ENTITY_IDS, ENTITY_NAMES } from '../items.constants';
import { OverlayService } from '../overlay.service';
import { DETAILS_OVERLAY_CONFIGS, DETAILS_OVERLAY_ESTIMATION_CONFIGS } from './config';
import { DETAILS_OVERLAY_MENU } from './detail-overlay.constants';
import { entityParamsOverlay } from './details-overlay.constants';
import {
  DetailOverlayMenu,
  DetailsOverlayData,
  EntitySPSpaces,
  NavigationObject,
  OPTIONS,
  OverlayField,
  SPRequest,
  UpgradedFormGroup,
} from './details-overlay.model';
import { DetailsOverlayService } from './details-overlay.service';
import {
  INFO_USER_RESOLVER_TOKEN,
  OVERLAY_UTILS_TOKEN,
  OverlayUtilsConfiguration,
  UserInfoResolver,
} from '../../../../../stacking-plan.token';
import { AvailabilitySpaceClass } from '../../../../../models/space/availability-space.class';
import { SpLinkOpportunityService } from '../../../../../shared/services/sp-link-opportunity.service';
import { DataObject } from '../../../../../models/data-object.models';
import { filterAndSetAvailability } from './config/availability.config';
import { geTenantType, getLeaseType } from '../details-modal/details-modal.constants';
import { FloorContainerRepository } from '../../../floor-container-repository.service';
import { StackPlanViewStateService } from '../../../../../state/sp-view-state.service';

@Component({
  selector: 'sp-details-overlay',
  templateUrl: './details-overlay.component.html',
  styleUrls: ['./details-overlay.component.scss'],
  providers: [DetailsOverlayService],
  standalone: false,
})
export class DetailsOverlayComponent implements OnInit, OnDestroy {
  public config: DetailsOverlayData = {} as DetailsOverlayData;
  public subsets: OverlayField[];
  public notesUpdate: OverlayField[];
  public footer: OverlayField;
  public data: AbstractSpaceClass = {} as AbstractSpaceClass;
  public totalTermYears: { year: number; month: number };
  public termCompletedPer: number;
  public overlayBarClass: string;
  /** @deprecated temporary usage */
  public showFloorIndexFeatureKey = SHOW_FLOOR_INDEX_FEATURE_KEY;
  public overlayFormGroup: UntypedFormGroup;
  public isEdit = false;
  public isEditable = false;
  public defaultOptions = { defaultTxt: null, rawData: true, label: null };
  public lookupFlag = false;
  public suiteTypeEnum = SuiteType;
  public conversionTypeEnum = ConversionType;
  public termDisplay: string;
  public termDisplayIsMasked: boolean;
  public isTrustedUser = false;
  public isTenantActive = false;
  public containerRecordFloors: DataObject[];
  public overlayMenus: DetailOverlayMenu[];
  public columns: Column[];
  public opportunities: DataObject[] = [];
  public hasAccessToOpportunities = true;
  public isOpportunityActive = false;
  public isConfidential = false;
  public isCIQDown = false;
  public floorId: number;
  public userInfo: IUser;
  public unaccountedSpace: number;
  public isOwnerOccupiedActiveInCatalog = false;

  private floorNumber: any;
  private propertyUsage: DataObject | null = null;
  // private leaseId: number;

  constructor(
    @Inject(INFO_USER_RESOLVER_TOKEN) private userInfoResolver: UserInfoResolver,
    @Inject(OVERLAY_UTILS_TOKEN) public overlayConfigs: OverlayUtilsConfiguration,
    public stackingPlanService: StackingPlanService,
    private overlayService: OverlayService,
    @Optional() private router: Router,
    private notificationService: NotificationService,
    private actionsToolbarService: ActionsToolbarService,
    public translationService: L10nTranslationService,
    private filtersService: FiltersService,
    private detailsOverlayService: DetailsOverlayService,
    protected store: Store,
    protected catalogService: CatalogsService,
    private spLinkOpportunityService: SpLinkOpportunityService,
    private floorContainerRepository: FloorContainerRepository,
    private stackPlanViewStateService: StackPlanViewStateService
  ) {
    this.userInfo = this.userInfoResolver.resolve();
  }

  ngOnInit() {
    if (!this.overlayService.overlayDialogData) {
      return;
    }
    const { space, floor, containerRecordFloors, unaccountedSpace } = this.overlayService.overlayDialogData;
    this.unaccountedSpace = unaccountedSpace;
    this.floorNumber = floor;
    this.data = space;
    this.containerRecordFloors = containerRecordFloors;
    this.overlayBarClass = this.overlayService.overlayBarClass;
    this.config = DETAILS_OVERLAY_CONFIGS[this.data.suiteType];
    this.isTenantActive = isTenantEntityActive();
    this.isOpportunityActive = isOpportunityTabActive();
    this.initTermBar();
    this.isTrustedUser = this.stackingPlanService.isTrustedUser();
    // ! NOTE(Danny): Not need it for US, as per Rob comment Fn will remain commented only in case of implementation on th US...
    // this.getOpportunities();
    this.extendSubsets(this.getCatalog(ENTITY_NAMES[this.data.suiteType]))
      .pipe(
        switchMap(subsets => {
          // Store columns in view state service for pipes to access
          this.stackPlanViewStateService.setColumns(this.columns);
          if (!this.isOwnerOccupiedActiveInCatalog) {
            subsets = subsets.filter(subset => subset.dataField !== 'ownerOccupied');
          }
          const lookups$ = this.getLookUps(subsets);
          if (lookups$.length) {
            return forkJoin(lookups$).pipe(map(responses => this.getSubSetValues(subsets, responses)));
          }
          return of([]);
        })
      )
      .subscribe(subsetWithValues => {
        this.subsets = subsetWithValues;
        this.lookupFlag = true;
        this.notesUpdate = this.config.notesUpdate?.filter(set => !!set.labelFn && set.labelFn(this.columns));
        this.footer = this.config.footer;
        if (
          this.data.suiteType === SuiteType.Availability ||
          this.data.suiteType === SuiteType.Tenant ||
          this.data.suiteType === SuiteType.Lease
        ) {
          this.formInit();
        }
        this.isEditable =
          this.isTrustedUser && this.data.enableEditEvent() && this.stackingPlanService.hasEDPWriteAccess();
        this.setOverlayMenus();
        const isSpaceWithUsage = ![SuiteType.NonRentable, SuiteType.Unaccounted].includes(this.data.suiteType);
        if (isSpaceWithUsage) this.setPropertyUsage();
      });
    const { floor_id } = this.containerRecordFloors.find(
      (efloor: DataObject) => efloor.floor_number === this.floorNumber
    );
    this.floorId = floor_id;
  }

  ngOnDestroy(): void {
    /* required by angular-l10n */
  }

  public checkConfidentiality() {
    const data = this.data as TenantSpaceClass;
    this.isConfidential = data.isUserLessThanRecordConf || data?.lease?.access_control?.private_data_f;
  }

  public navigateToCIQ(opportunity: DataObject): void {
    const path = `${this.stackingPlanService.ciqPath}/${opportunity?.Id}`;
    window.open(path, '_blank');
  }

  public disableLinkOpportunity() {
    const leaseId = (this.data as TenantSpaceClass).leaseId;
    return !leaseId || this.isConfidential || this.isCIQDown;
  }

  public linkOpportunity(): void {
    const data = this.data as TenantSpaceClass;
    const record = {};
    record['entity'] = data.lease.id;
    record['company_contact_role_addresses'] = data.tenantInfo.map(item => {
      return { company_id: item.companyId };
    });
    const leaseid = (this.data as TenantSpaceClass).leaseId;
    this.spLinkOpportunityService.triggerOpportunity(leaseid, record);
  }

  private getCatalog(suiteType: SuiteType): Observable<CatalogResponse<Column>> {
    return this.catalogService
      .getColumns(suiteType, CatalogMethod.Default, {
        mapAllRelations: true,
      })
      .pipe(
        tap(sections => {
          if (suiteType === SuiteType.Lease) {
            this.isOwnerOccupiedActiveInCatalog = findOwnerOccupiedColumn(
              sections,
              LeaseColumns.LeaseCompDetails_OwnerOccupied
            );
          }
        })
      );
  }

  private extendSubsets(sections$: Observable<CatalogResponse<Column>>): Observable<OverlayField[]> {
    const extension = DETAILS_OVERLAY_ESTIMATION_CONFIGS[this.data.suiteType];
    let subsets = this.config.subsets;
    // To extend subsets, we need to first check whether Tenancy is disbled, extension exits for the space type and it should be non-CBRE deal
    if (COLUMN_MAPPER_ENTITIES.includes(this.data.suiteType)) {
      return sections$.pipe(
        map(sections => {
          // We fetch the columns mapped with all the relations and create an array of columns.
          this.columns = sections[ENTITY_NAMES[this.data.suiteType]].reduce((acc, rec) => {
            return [...acc, ...rec.columns];
          }, []);

          // Filtering for Avilability to be made separately
          if (this.data.suiteType === SuiteType.Availability) {
            subsets = filterAndSetAvailability(this.data as AvailabilitySpaceClass, this.columns, subsets);
          }

          subsets = subsets.filter(
            set => (set.labelFn && set.labelFn(this.columns)) || (set.isLinkedOpportunities && this.isOpportunityActive)
          );

          return subsets.map(set => {
            //// To extend subsets, we need to first check whether Tenancy is disbled, extension exits for the space type and it should be non-CBRE deal
            if (!this.isTenantActive && extension && this.isNotACbreDeal(this.data)) {
              // Loop over the subsets and check if the extension exists for the input.
              const estimated = extension[set.dataField] || null;
              // If yes, then pass columns to the conditon to check whether to add extension or not.
              if (!!estimated?.condition(this.columns)) {
                return { ...set, estimated };
              }
            }

            return { ...set };
          });
        })
      );
    }
    return sections$.pipe(map(() => subsets));
  }

  private isNotACbreDeal(data: DataObject): boolean {
    return !data?.lease?.layout_cbre_f;
  }

  public cancelEdit() {
    this.isEdit = false;
    this.formInit();
  }

  public save() {
    if (this.overlayFormGroup.valid) {
      const originalSpaceSize = this.data.getAreaSpace();
      const finalSpaceSize = this.overlayFormGroup.value.formGroupSpace.spaceSize;
      const finalSpaceSizeUOM = this.overlayFormGroup.value.formGroupSpace.spaceSizeUOM;
      let selectedSuiteNumber: string;
      let remainingSpace = 0;
      let suiteId: number;
      if (
        originalSpaceSize != null &&
        finalSpaceSize != null &&
        originalSpaceSize > this.formatValue(finalSpaceSize, 'numeric')
      ) {
        remainingSpace = originalSpaceSize - this.formatValue(finalSpaceSize, 'numeric');
      }

      const request: SPRequest = this.createRequest();
      if (this.data.suiteType === SuiteType.Availability) {
        selectedSuiteNumber = request.availabilitySpace.suiteNumber;
        suiteId = request.availabilitySpace.suiteId;
      } else if (this.data.suiteType === SuiteType.Tenant) {
        selectedSuiteNumber = request.tenantSpace.suiteNumber;
        suiteId = request.availabilitySpace.suiteId;
      }

      const floor = this.containerRecordFloors.find(efloor => efloor.floor_number === this.floorNumber);
      if (floor === undefined) {
        return false;
      }
      this.stackingPlanService
        .alertNonTrustedUser()
        .pipe(
          filter(Boolean),
          switchMap(() =>
            this.stackingPlanService.alertDuplicateSuite(floor, selectedSuiteNumber, this.data.suiteType, suiteId)
          )
        )
        .pipe(filter(Boolean))
        .subscribe(() => {
          this.sendUpdateRequest(request, remainingSpace, finalSpaceSizeUOM, this.floorNumber, selectedSuiteNumber);
        });
    }
  }

  public getVerifiedTextAvailability() {
    const verifiedDate = (this.data as AvailabilitySpaceClass).verified_ts;
    if (verifiedDate) {
      const verifiedi10 = this.translationService.translate('recordsSearch.verified');
      const dateFormat = formatDate(verifiedDate);
      return `${verifiedi10} ${dateFormat}`;
    }
    return 'recordsSearch.verify';
  }

  public newTenantAvailabilityFromUnaccounted(entity: string) {
    const remainingSpace = this.data.getAreaSpace();
    const remainingSpaceUOM = this.data.getAreaSpaceUOM();
    this.stackingPlanService.createSpace({
      entityName: entity,
      propertyId: this.stackingPlanService.propertyId,
      containerRecordFloors: this.containerRecordFloors || [],
      floor: this.floorNumber,
      space: this.data,
      suiteNumber: '',
      remainingSpace,
      remainingSpaceUOM,
    });
    this.overlayService.disposeBox();
  }
  public onSpaceReplacement(conversionType: ConversionType) {
    let preReplacementAction$: Observable<EfficiencyTransport | string> = of('');
    if (conversionType === ConversionType.TenancyToNrs) {
      preReplacementAction$ = this.detailsOverlayService.convertTenancyToNRS(this.floorNumber, this.data);
    } else if (conversionType === ConversionType.NrsToAvailability) {
      preReplacementAction$ = this.detailsOverlayService.convertNRStoAvailability(
        this.floorNumber,
        this.containerRecordFloors,
        this.data
      );
    }

    preReplacementAction$.subscribe(preparedEfficiencyTransport => {
      const simpleEfficiencyTransport = {
        space: this.data,
        floor: this.floorNumber,
        conversionType,
        containerRecordFloors: this.containerRecordFloors,
      };
      const efficiencyTransport: EfficiencyTransport =
        preparedEfficiencyTransport !== ''
          ? (preparedEfficiencyTransport as EfficiencyTransport)
          : simpleEfficiencyTransport;
      this.stackingPlanService.replaceSpace(efficiencyTransport);
      this.overlayService.disposeBox();
    });
  }

  /**
   * Entity name will be received from subsets configuration,
   * when clicking any subset item. If entity and entity record id exists, will
   * navigate to the respected record details page and closes the dialog box
   * else stays in same screen
   */
  public navigateToEntityRecord(navigationObject: NavigationObject<AbstractSpaceClass>, EventType: string) {
    if (!navigationObject) {
      return;
    }
    const { entity, getEntityField } = navigationObject;
    if (entity === SuiteType.NonRentable && this.data instanceof NonRentableSpaceClass) {
      if (!this.stackingPlanService.isTrustedUser()) {
        return null;
      }
      const data: NonRentableData = {
        item: this.data as NonRentableSpaceClass,
        floorNo: this.overlayService.floorNo,
        totalNumberOfFloors: this.overlayService.totalNumberOfFloors,
      };
      return this.updateNonRentableSpace(data);
    }
    const entityName =
      !this.isTenantActive && entity === SuiteType.Tenant
        ? ENTITY_NAMES['company']
        : this.getEntityNameToNavigate(EventType, entity);
    const entityID = getEntityField == null ? this.getEntityId(entityName) : getEntityField(this.data);
    if (entityID) {
      const url = this.stackingPlanService.getNavigationURL(entityName.toLowerCase(), entityID);
      window.open(url, '_blank');
    }
  }

  private getEntityId(entityName: string): number {
    return entityName == ENTITY_NAMES.company ? this.data['tenant']['company_id'] : this.data[ENTITY_IDS[entityName]];
  }
  public deleteNRSpace() {
    const { suiteId } = this.data;
    this.detailsOverlayService.prepareDeleteNRSRequest$(this.floorNumber, suiteId).subscribe(() => {
      this.stackingPlanService.setSpaceChanges();
      this.overlayService.disposeBox();
    });
  }

  public emitNumericData(overlayFormControl: UntypedFormControl, dataField: string) {
    const field = this.subsets.find(a => a.dataField === dataField);
    if (field.unit) {
      const uomControl = (this.overlayFormGroup.controls[field.formGroup] as UntypedFormGroup).controls[
        field.unit.dataField
      ];
      if (overlayFormControl.value != null && uomControl.value == null) {
        uomControl.setValue(field.unit.values[0].key);
        uomControl.markAsDirty();
      }
    }
    if (field.estimated) {
      const estimatedControl = (this.overlayFormGroup.controls[field.formGroup] as UntypedFormGroup).controls[
        field.estimated.dataField
      ];
      if (overlayFormControl.value != null && estimatedControl.value == null) {
        estimatedControl.setValue(field.estimated.values[0].key);
        estimatedControl.markAsDirty();
      }
    }
  }

  public verifyEntity(): void {
    if (this.isTrustedUser) {
      (this.data as AvailabilitySpaceClass).verified_ts = new Date();
      this.stackingPlanService.sendVerifiedEntity(this.data.suiteType, this.data['id']).subscribe(() => {
        const message = `${this.translationService.translate('recordsSearch.verifiedSuccessfully')} ${
          this.data.suiteType
        } ${this.translationService.translate('recordsSearch.record')}`;
        const closeMessage = this.translationService.translate('recordsSearch.close');
        this.notificationService.showSnackBack(message, closeMessage);
        this.setOverlayMenus();
      });
    }
  }

  public createNonRentableSpaceFromUnaccounted() {
    const data: NonRentableData = {
      item: <NonRentableSpaceClass>this.data,
      floorNo: this.overlayService.floorNo,
      totalNumberOfFloors: this.overlayService.totalNumberOfFloors,
      isUnaccounted: true,
    };

    this.updateNonRentableSpace(data);
    this.overlayService.disposeBox();
  }

  private confirmDeleteSuite(suiteType: string) {
    return this.notificationService.openDialog(
      ConfirmDialogSPComponent,
      {
        message: this.translationService.translate('overlayDetails.duplicateSuiteDialogConfirmation.' + suiteType),
        confirmText: this.translationService.translate('commonLabels.confirm'),
        cancelText: this.translationService.translate('commonLabels.cancel'),
      },
      { panelClass: 'alert-modals' }
    );
  }
  private formInit() {
    // * Hacked formGroup type to allow component scope assignation...
    const form = new UntypedFormGroup({});
    [...this.subsets, ...this.notesUpdate].forEach(config => {
      if (config.dataField) {
        const control = new UntypedFormControl('', config.validators || null);
        if (config.formGroup) {
          if (form && form.contains(config.formGroup)) {
            (form.controls[config.formGroup] as UntypedFormGroup).addControl(config.dataField, control);
          } else {
            const fromGroup = {};
            fromGroup[config.dataField] = new UntypedFormControl(config.dataField, control);
            form.addControl(config.formGroup, new UntypedFormGroup(fromGroup));
          }
          if (config.unit) {
            const unitControl = new UntypedFormControl('', config.unit.validators || null);
            (form.controls[config.formGroup] as UntypedFormGroup).addControl(config.unit.dataField, unitControl);
          }
          if (config.estimated) {
            const estimatedControl = new UntypedFormControl('', config.estimated.validators || null);
            (form.controls[config.formGroup] as UntypedFormGroup).addControl(
              config.estimated.dataField,
              estimatedControl
            );
          }
        } else {
          form.addControl(config.dataField, control);
        }
      }
    });
    this.addGroupValidators(form);
    this.overlayFormGroup = form;
  }

  private addGroupValidators(form: UntypedFormGroup) {
    this.config.validators.forEach(validator => {
      const formGroupToValidate = form.controls[validator.groupName] as UpgradedFormGroup;
      if (formGroupToValidate) {
        formGroupToValidate.setValidators(validator.validator);
        // * Add component scope for custom validation data access...
        formGroupToValidate.component = this;
      }
    });
  }

  /**
   * TECH DEBT (Sanjay):
   * duplicated blocks need to be removed
   *
   */
  private createRequest(): SPRequest {
    const request: SPRequest = {
      availability: {},
      availabilitySpace: {},
      tenantSpace: {},
      tenant: {},
      leaseSpace: {},
      lease: {},
    };
    /**
     * Refers to https://jira.cbre.com/browse/MIQ-19439...
     * Removed dirty validation on form field.
     * Send all form data at once to avoid issues with EDP when a SP is being modified.
     */
    [...this.subsets, ...this.notesUpdate].forEach(config => {
      if (config.dataField) {
        if (config.formGroup) {
          this.setRequestWithFormGroup(config, request);
        } else {
          const control = this.overlayFormGroup.controls[config.dataField];
          request[this.getEntityType(config.dataField)][config.dataField] = this.formatValue(
            control.value,
            config.inputType
          );
        }
      }
    });
    return request;
  }

  private setRequestWithFormGroup(config: DataObject, request: SPRequest) {
    const control = (this.overlayFormGroup.controls[config.formGroup] as UntypedFormGroup).controls[config.dataField];
    request[this.getEntityType(config.dataField)][config.dataField] = this.formatValue(control.value, config.inputType);
    if (config.unit) {
      const uomControl = (this.overlayFormGroup.controls[config.formGroup] as UntypedFormGroup).controls[
        config.unit.dataField
      ];
      request[this.getEntityType(config.dataField)][config.unit.dataField] = this.formatValue(
        uomControl.value,
        config.unit.inputType
      );
    }
    if (config.estimated) {
      const estimatedControl = (this.overlayFormGroup.controls[config.formGroup] as UntypedFormGroup).controls[
        config.estimated.dataField
      ];
      request[this.getEntityType(config.estimated.dataField)][config.estimated.dataField] = this.formatValue(
        estimatedControl.value,
        config.estimated.inputType
      );
    }
  }

  private formatValue(value: any, inputType: string) {
    if (value != null && ['numeric', 'currency'].includes(inputType)) {
      const val = Number.parseFloat(value.replace(/,/g, ''));
      return Number.isNaN(val) ? null : val;
    }
    return value;
  }

  private getEntityType(field: string): EntitySPSpaces {
    if (this.data.suiteType === SuiteType.Availability) {
      return ['suiteNumber', 'floorNumber'].includes(field)
        ? EntitySPSpaces.AvailabilitySpace
        : EntitySPSpaces.Availability;
    }
    return this.getTenantLeaseType(field);
  }

  private getTenantLeaseType(field: string): EntitySPSpaces {
    const isTenantActive = isTenantEntityActive();
    return isTenantActive ? geTenantType(field) : getLeaseType(field);
  }

  private sendUpdateRequest(
    request: SPRequest,
    remainingSpace: number,
    remainingSpaceUOM: string,
    floor: string,
    suiteNumber: string
  ) {
    const $requests = this.getRequests(request);
    if ($requests.length > 0) {
      forkJoin($requests).subscribe(() => {
        this.overlayService.disposeBox();
        this.stackingPlanService.setSpaceChanges();
        this.filtersService.resetFilter$.next();
        if (remainingSpace > 0) {
          this.stackingPlanService.setNewAvailabityTenancyCreation({
            remainingSpace,
            remainingSpaceUOM,
            floor,
            suiteNumber,
          });
        }
      });
    }
  }

  private getRequests(request: SPRequest): Observable<DataObject>[] {
    const $requests: Observable<DataObject>[] = [];

    const overlayFormGroupValue = this.overlayFormGroup.value;
    const { propertyId } = this.stackingPlanService;
    const propertyUsageId = this.propertyUsage?.id || 0;

    for (const [key, value] of Object.entries(request)) {
      if (Object.keys(value).length > 0) {
        const { entity, edpMethod, errorMessage, reqClass, entityKey } = OPTIONS[key];
        const entityParams = this.getEntityParams(overlayFormGroupValue, propertyId, propertyUsageId, value, key);

        const floorsData = key === 'leaseSpace' ? this.getFloorsDataForLeaseSpace() : undefined;

        const { payloads } =
          key === 'leaseSpace'
            ? new reqClass(entityParams, edpMethod, floorsData)
            : new reqClass(entityParams, edpMethod);

        $requests.push(
          this.actionsToolbarService
            .updateOverlapFormData(payloads, entity, this.data[entityKey])
            .pipe(this.actionsToolbarService.errorHandling(errorMessage))
        );
      }
    }
    return $requests;
  }

  private getFloorsDataForLeaseSpace(): DataObject[] {
    const repositoryFloors = this.floorContainerRepository.floorData;
    return repositoryFloors?.length ? repositoryFloors : this.containerRecordFloors;
  }

  private getEntityParams(
    overlayFormGroupValue: DataObject,
    propertyId: number,
    propertyUsageId: number,
    value: DataObject,
    entitySP: string
  ): DataObject {
    const isNewFloorNumber = overlayFloorNumber => {
      return this.floorNumber !== overlayFloorNumber;
    };
    let payloadFloorNumber = this.floorNumber;
    let payloadFloorId = this.floorId;
    if (isNewFloorNumber(overlayFormGroupValue['floorNumber'])) {
      const newAvailFloorNum = overlayFormGroupValue['floorNumber'];
      const { floor_id, floor_number } = this.containerRecordFloors.find(
        (floor: DataObject) => floor.floor_number === newAvailFloorNum
      );
      //TODO (Aurelio): A validator is required for the floor number field to ensure that the enterred floor number is a valid one
      payloadFloorNumber = floor_number ?? this.floorNumber;
      payloadFloorId = floor_id ?? this.floorId;
    }
    const params = entityParamsOverlay(
      this.data,
      overlayFormGroupValue.formValue.formGroupSpace.spaceSizeUOM,
      payloadFloorNumber,
      propertyId,
      propertyUsageId,
      payloadFloorId
    );
    return { ...params[entitySP], ...value };
  }
  /**  eventType is added to check from which part of the html is calling this function
   *   based on this redirection is handled
   */
  private getEntityNameToNavigate(EventType: string, entity: string): string {
    if (this.isTenantActive && entity === SuiteType.Tenant) {
      return ENTITY_NAMES.tenancy;
    }
    if (!this.isTenantActive && entity === SuiteType.Lease && EventType !== 'bodyEvent') {
      return ENTITY_NAMES.company;
    }
    return ENTITY_NAMES[entity];
  }
  private updateNonRentableSpace(data: NonRentableData) {
    this.notificationService
      .openDialog<{ floorNumber: string; nonRentableSpace: NonRentableSpaceClass }>(NonRentableSpaceComponent, data, {
        panelClass: 'table-modals',
      })
      .pipe(filter(nonRentableSpace => nonRentableSpace != null))
      .subscribe(() => {
        this.stackingPlanService.setSpaceChanges();
        // TODO: implement full offline behavior
        // const updatedFloorInfo = updateNonRentableSpaceInto(floorsData, floorNumber, nonRentableSpace);
        // this.stackingPlanService.setUpdatedStackingData({
        //   updatedFloorData: updatedFloorInfo.map(floor => floor.toEDPFloorSpaceInfo()),
        // });
        this.overlayService.disposeBox();
      });
  }

  private initTermBar() {
    if (this.data && this.data instanceof TenantSpaceClass) {
      const { startDate, endDate } = this.data.getSpaceDates();
      this.termDisplayIsMasked = isMasked(startDate) && isMasked(endDate);
      if (startDate != null && endDate != null && !isMasked(startDate) && !isMasked(endDate)) {
        const termInfo = this.termYearsMonthsCalc(moment(startDate), moment(endDate));
        // total term years
        this.totalTermYears = {
          year: termInfo.year,
          month: termInfo.month,
        };
        // total term completed percentage as of now
        this.termCompletedPer = termInfo.termCompletedPer;
      }
    } else {
      this.termCompletedPer = 0;
    }
  }

  /**
   * It will returns the total number of the years and months between term start
   * year and term end year. And term start year and current year
   */
  private termYearsMonthsCalc(
    termStartYear: Moment,
    termEndYear: Moment
  ): { year: number; month: number; termCompletedPer: number } {
    const totalTermMonths = this.totalMonthsCalc(termStartYear, termEndYear);
    const termDuration = moment.duration(totalTermMonths, 'months');
    const currentTotalTermMonths = this.totalMonthsCalc(termStartYear, moment());
    const termCompletedPer = (currentTotalTermMonths / totalTermMonths) * 100;
    return { year: termDuration.years(), month: termDuration.months(), termCompletedPer };
  }

  /** It will return the total number of months between two years */
  private totalMonthsCalc(startYear: Moment, endYear: Moment) {
    return endYear.add(1, 'days').diff(startYear, 'months', false);
  }

  private setOverlayMenus() {
    const detailsOverlayMenu = DETAILS_OVERLAY_MENU(this);
    const menus = detailsOverlayMenu[this.data?.suiteType];
    this.overlayMenus = (menus || []).filter(m => !m?.hide);
  }

  private getLookUps(subsets: OverlayField<AbstractSpaceClass>[]): Observable<{
    key: string;
    value: LovValues[];
  }>[] {
    const lookupCategories = [];
    subsets.forEach(subset => {
      lookupCategories.push(subset.lookupCategory);
      lookupCategories.push(subset?.unit?.lookupCategory);
      lookupCategories.push(subset?.estimated?.lookupCategory);
    });
    const uniqueCategories: string[] = Array.from(new Set(lookupCategories.filter(Boolean)));
    return uniqueCategories.map(lookupCategory => {
      return this.stackingPlanService.getLovValues(lookupCategory).pipe(
        map(res => {
          return { key: lookupCategory, value: res };
        })
      );
    });
  }

  private getSubSetValues(subsets: OverlayField<AbstractSpaceClass>[], responses: DataObject[]) {
    return subsets.map(subset => {
      if (subset.lookupCategory) {
        subset = { ...subset, values: this.getValuesFromResponse(responses, subset.lookupCategory) };
      }
      if (subset?.unit?.lookupCategory) {
        const unit = { ...subset.unit, values: this.getValuesFromResponse(responses, subset.unit.lookupCategory) };
        subset = { ...subset, unit };
      }
      if (subset?.estimated?.lookupCategory) {
        const estimated = {
          ...subset.estimated,
          values: this.getValuesFromResponse(responses, subset.estimated.lookupCategory),
        };
        subset = { ...subset, estimated };
      }
      return { ...subset };
    });
  }

  private getValuesFromResponse(responses: DataObject[], lookupCategory: string) {
    return (responses.find(obj => obj.key === lookupCategory) || {}).value;
  }

  private setPropertyUsage() {
    let propertyUsageRef: any;
    if (this.data.suiteType === 'availability') {
      propertyUsageRef = this.data['refPropertyUsageTypeDesc'];
    } else {
      const isTenantActive = isTenantEntityActive();
      const entity = !isTenantActive && this.data.suiteType === SuiteType.Tenant ? 'lease' : 'tenant';
      propertyUsageRef = this.data[entity]['ref_property_usage_type_desc'];
    }
    this.propertyUsage = this.stackingPlanService.getPropertyUsage(propertyUsageRef);
  }
}
